import React, { useEffect, useState } from 'react'
import "../../styles/profileStyles/myProfileStrategies.css";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer
} from "recharts";
import { useParams } from 'react-router-dom';
import BeatLoader from 'react-spinners/BeatLoader';


export default function MyProfileStrategies() {
    const [cardDatas, setCardDatas] = useState(null);

    const { username: targetUsername } = useParams();

    // const cardDatas = {
    //     strategiesSuccessRateChart: [
    //         { date: "Week 1", rate: 45 },
    //         { date: "Week 2", rate: 52 },
    //         { date: "Week 3", rate: 61 },
    //         { date: "Week 4", rate: 38 },
    //     ],

    //     strategiesProfitChart: [
    //         { date: "Week 1", profit: 1200 },
    //         { date: "Week 2", profit: -300 },
    //         { date: "Week 3", profit: 800 },
    //         { date: "Week 4", profit: 1500 },
    //     ],

    //     succesRateByStrategies: [
    //         { id: 1, name: "Safe Betting Strategy", rate: 62.5, total: 40 },
    //         { id: 2, name: "Risky Combo", rate: 28.3, total: 25 },
    //         { id: 3, name: "Balanced System", rate: 51.1, total: 60 },
    //     ],

    //     profitRateByStrategies: [
    //         { id: 1, name: "Safe Betting Strategy", profit: 3200 },
    //         { id: 2, name: "Risky Combo", profit: -1200 },
    //         { id: 3, name: "Balanced System", profit: 1800 },
    //     ],

    //     avgOddsByStrategies: [
    //         { id: 1, name: "Safe Betting Strategy", avgOdds: 1.85 },
    //         { id: 2, name: "Risky Combo", avgOdds: 6.40 },
    //         { id: 3, name: "Balanced System", avgOdds: 2.75 },
    //     ]
    // };



    useEffect(() => {
        fetch(`https://focifanatik.hu/api/profile_API/profileStrategies.php?username=${targetUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setCardDatas(data);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);

    if (!cardDatas) {
        return (
            <>
                <div className='loading-bg-profileBar'><BeatLoader color="white" size={55} /></div>
                <div className='loading-bg-content'></div>
            </>
        );
    }
    return (
        <>

            <div className='myProfileStrategiesPage-topProfileBar'>

                <h1><i class="bi bi-bookmarks"></i></h1>
                <h1>asd</h1>

            </div>

            {/* TARTALOM */}
            <div className='myProfileStrategiesPage-content'>
                <div className='myProfileStrategiesStatsGrid'>

                    <div className='myProfileStrategiesCardOne'>
                        <h3>Stratégiáim találati aránya</h3>

                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={cardDatas.strategiesSuccessRateChart}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="rate"
                                    stroke="oklch(68% 0.24475 141.51)"
                                    strokeWidth={3}
                                />
                            </LineChart>
                        </ResponsiveContainer>

                    </div>

                    <div className='myProfileStrategiesCardTwo'>
                        <h3>Stratégiáim profitjai</h3>

                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={cardDatas.strategiesProfitChart}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="date" />
                                <YAxis />
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="profit"
                                    stroke="oklch(68% 0.24475 141.51)"
                                    strokeWidth={3}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>

                    <div className='myProfileStrategiesCardThree'>
                        <h3>Legjobban teljesitő stratégiáim találati arány szerint</h3>

                        <div className='myProfileStrategyStatBoxWrapper'>
                            {cardDatas.succesRateByStrategies.map((stat) => (
                                <div className='myProfileStrategyStatBox'>

                                    <div className='myProfileStrategyStatBoxDetails'>
                                        <h4>{stat.name.slice(0, 15)}</h4>
                                        <p className={`${stat.rate > 50 ? "myProfileStrategiesStatBoxDetailsGreen" : stat.rate < 30 ? "myProfileStrategiesStatBoxDetailsRed" : "myProfileStrategiesStatBoxDetailsYellow"}`}>
                                            {stat.rate}%
                                        </p>
                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>

                    <div className='myProfileStrategiesCardFour'>
                        <h3>Legjobban teljesitő stratégiáim profit szerint</h3>

                        <div className='myProfileStrategyStatBoxWrapper'>

                            {cardDatas.profitRateByStrategies.map((stat) => (
                                <div className='myProfileStrategyStatBox'>

                                    <div className='myProfileStrategyStatBoxDetails'>
                                        <h4>{stat.name.slice(0, 15)}</h4>
                                        <p className={`${stat.profit > 0 ? "myProfileStrategiesStatBoxDetailsGreen" : "myProfileStrategiesStatBoxDetailsRed"}`}>
                                            {stat.profit}
                                        </p>
                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>

                    <div className='myProfileStrategiesCardFive'>
                        <h3>Stratégiáim legnagyobb átlag oddsai</h3>

                        <div className='myProfileStrategyStatBoxWrapper'>

                            {cardDatas.avgOddsByStrategies.map((stat) => (
                                <div className='myProfileStrategyStatBox'>

                                    <div className='myProfileStrategyStatBoxDetails'>
                                        <h4>{stat.name.slice(0, 15)}</h4>
                                        <p className={`${stat.avgOdds < 2.00 ? "myProfileStrategiesStatBoxDetailsGreen" : stat.avgOdds > 10.00 ? "myProfileStrategiesStatBoxDetailsRed" : "myProfileStrategiesStatBoxDetailsYellow"}`}>
                                            {stat.avgOdds}%
                                        </p>
                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}
